module.exports = __webpack_public_path__ + "img/67_20.a86bde39.png";